var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('Modal', {
    attrs: {
      "title": _vm.title,
      "width": "90"
    },
    model: {
      value: _vm.modalVisible,
      callback: function callback($$v) {
        _vm.modalVisible = $$v;
      },
      expression: "modalVisible"
    }
  }, [_c('ul', {
    staticClass: "detail-box"
  }, _vm._l(_vm.columns, function (prop, index) {
    return _c('li', {
      key: index
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(prop.title) + "\n            ")]), _c('div', {
      staticClass: "content"
    }, [_vm._v("\n                " + _vm._s(prop.render ? prop.render(_vm.h, {
      row: _vm.data
    }) : _vm.data[prop.key]) + "\n            ")])]);
  }), 0), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_vm._t("btn_footer"), _c('Button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function click($event) {
        _vm.modalVisible = false;
      }
    }
  }, [_vm._v("取消")])], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };